import * as z from "zod/v4";
import { IntegrationTypeSchema } from "./integration-type.js";
import { ConnectionStatusSchema } from "./connection-status.js";
import { IntegrationFilterV2Schema } from "./integration-filter-v2.js";
import { IntegrationCredentialsSchema } from "./credentials.js";
import { IntegrationMetadataSchema } from "./metadata.js";

const IntegrationV2Schema_ = z.object({
  id: z.string(),
  merchantId: z.string(),
  type: IntegrationTypeSchema,
  name: z.string(),
  status: ConnectionStatusSchema,
  metadata: IntegrationMetadataSchema.optional(),
  credentials: IntegrationCredentialsSchema.optional(),
  createdAt: z.string(),
  updatedAt: z.string(),
  consentMode: z.boolean().optional(),
  statusMessage: z.string().optional(),
  smartQualify: z.boolean().optional(),
  filters: z.array(IntegrationFilterV2Schema),
});
export const IntegrationV2Schema: z.ZodType<IntegrationV2> =
  IntegrationV2Schema_;
export interface IntegrationV2 extends z.infer<typeof IntegrationV2Schema_> {}
